<div class="documents m-d-block">
    @for (config of documentConfigs; track config) {
    <div class="col-3" [hidden]="(appFacadeService.isDocumentExists(config.documentType) | async) === false">
        <por-document-button
            [label]="config.label | translate"
            [featureToken]="config.featureToken"
            [visible]="(appFacadeService.isDocumentExists(config.documentType) | async) ?? false"
            [loading]="(appFacadeService.isDocumentLoading(config.documentType) | async) ?? false"
            [featureName]="config.featureName"
            [uiUrl]="uiUrl"
            [imgUrl]="config.imgUrl"
            (onclick)="openDocumentUrl(config.documentType)" />
    </div>
    } @if ((appFacadeService.checkIfDocumentsExistAfterLoading() | async) === false) {
    <div class="text-align-center doc-notfound">
        <div>{{ 'ProductDetailsNoDocumentsFound' | translate }}</div>
    </div>
    }
</div>
